/* jslint browser: true */
import React, { Component } from 'react';
import axios from 'axios';
import { apiUrl } from '../lib/constants.js';

import PageBlock from './annexes/PageBlock';
import AddBlockButton from './annexes/AddBlockButton';

/**
 * Page Annexes
 */
class Annexes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            blocks: []
        };

        this.onBlockAdd = this.onBlockAdd.bind(this);
        this.moveBlock = this.moveBlock.bind(this);
        this.removeBlock = this.removeBlock.bind(this);
        this.closeOtherBlocks = this.closeOtherBlocks.bind(this);
    }

    componentDidMount() {
        axios.get(`${apiUrl}/api/v1/isAdmin`).then(response => {
            if (response.data === 0) {
                window.location.href = '/login?c';
            }
            this.initAnnexes();
        });
    }

    /**
     * Initialise la liste des annexes
     */
    initAnnexes() {
        axios.get(apiUrl + '/api/v1/admin/annexe').then(response => {
            const openedBlock = this.state.blocks.find(
                block => block.isBlockOpen
            );

            const data = response.data;

            data.forEach(item => {
                item.isBlockOpen =
                    openedBlock && openedBlock.id_annexe === item.id_annexe;
            });

            this.setState({
                blocks: data
            });
        });
    }

    /**
     * Ajoute un bloc
     * @param {type} newBlock Le bloc à ajouter
     */
    onBlockAdd(newBlock) {
        this.setState(prevState => ({
            blocks: prevState.blocks.concat([newBlock])
        }));
    }

    /**
     * Modifie la position du bloc en bdd, puis rafraîchit la liste des blocs
     * @param {type} block Le bloc à déplacer
     * @param {type} way Vaut 'up' quand on monte le bloc, vaut 'down' quand on le descend
     */
    moveBlock(block, way) {
        axios
            .post(apiUrl + '/api/v1/admin/annexe/' + block.id_annexe, {
                moveUp: way === 'up'
            })
            .then(() => {
                this.initAnnexes();
            });
    }

    /**
     * Supprime un bloc
     * @param {type} block Le bloc à supprimer
     */
    removeBlock(block) {
        axios
            .delete(apiUrl + '/api/v1/admin/annexe/' + block.id_annexe)
            .then(() => {
                this.setState(prevState => {
                    const blocks = prevState.blocks.slice();

                    const blockIndex = blocks.findIndex(
                        item => item.id_annexe === block.id_annexe
                    );

                    blocks.splice(blockIndex, 1);

                    return { blocks };
                });
            });
    }

    /**
     * Ferme tous les accordéons, hormis celui passé en entrée
     * @param {type} idAnnexe
     */
    closeOtherBlocks(idAnnexe) {
        this.setState(prevState => {
            const blocks = prevState.blocks.slice();

            blocks.forEach(item => {
                item.isBlockOpen = item.id_annexe === idAnnexe;
            });

            return { blocks };
        });
    }

    render() {
        return (
            <div>
                {this.state.blocks
                    .sort((a, b) => a.ordre - b.ordre)
                    .map(item => (
                        <div
                            className="form-row row-annexe"
                            key={item.id_annexe}
                            style={{ marginTop: '10px' }}
                        >
                            <div className="col-sm-12">
                                <div className="col-sm-3" />
                                <div className="col-sm-6 offset-sm-3">
                                    <PageBlock
                                        block={item}
                                        moveBlock={this.moveBlock}
                                        removeBlock={this.removeBlock}
                                        isBlockOpen={item.isBlockOpen}
                                        closeOtherBlocks={this.closeOtherBlocks}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                <div style={{ textAlign: 'center' }}>
                    <AddBlockButton onBlockAdd={this.onBlockAdd} />
                </div>
            </div>
        );
    }
}

export default Annexes;



// WEBPACK FOOTER //
// ./src/components/Annexes.js